<template>
  <h4 :style="{ color: textColor }">
    <slot></slot>
  </h4>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue"
import { useThemeColors } from "features/common/theme/useTheme"
import { Color } from "constants/theme"

export default defineComponent({
  name: "Header4",
  props: {
    color: {
      type: String as PropType<Color>,
      default: "textColor",
    },
  },
  setup(props) {
    const themeColors = useThemeColors()
    const textColor = computed(() => themeColors[props.color])
    return {
      textColor,
    }
  },
})
</script>

<style scoped>
h4 {
  font-weight: 700;
  font-family: system-ui !important;
  font-size: 16px;
  margin-bottom: 0;
}
</style>
